import { useEffect, useState, memo, useCallback } from "react";
import { Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import List from "./List";
import { callAPIInterface } from "../constants";
import { useSession } from "../../hooks/useSession";
import CommonSkeleton from "../CommonSkeleton";
import Dialog from "../dialog/Dialog";
import { setAppList } from "../../redux/actions";

function CollectionDetailDialog({
  isOpen,
  setIsOpen,
  collectionId,
  collectionName,
}) {
  const dispatch = useDispatch();
  const { session } = useSession();
  const appList = useSelector((state) => state.common.appList);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    //reset appList on unmount
    return () => {
      dispatch(setAppList([]));
    };
  }, []);

  const fetchCollectionList = useCallback(async () => {
    try {
      setIsLoading(true);
      const collectionList = await callAPIInterface(
        "POST",
        `/manage-app/apps/collection/${collectionId}`,
        JSON.stringify({
          restricted_countries: {
            not_contains: session?.account?.account?.country,
          },
        })
      );
      dispatch(setAppList(collectionList));
    } catch (err) {
      console.log("Error while fetching collection detail:", err);
    } finally {
      setIsLoading(false);
    }
  }, [collectionId, session]);

  useEffect(() => {
    if (collectionId && session && isOpen) {
      fetchCollectionList();
    }
  }, [collectionId, session, isOpen, fetchCollectionList]);

  const listSkeleton = () => {
    return (
      <Box className="list-box" sx={{ padding: "12px 15px" }}>
        <Box display="flex" gap="10px">
          <CommonSkeleton
            variant="rectangular"
            height="56px"
            width="56px"
            borderRadius="14px"
          />
          <Box>
            <CommonSkeleton variant="text" />
            <CommonSkeleton variant="text" width="200px" />
          </Box>
        </Box>
        <CommonSkeleton
          variant="square"
          height="33px"
          width="70px"
          borderRadius="8px"
        />
      </Box>
    );
  };

  return (
    <Dialog
      isOpenModal={isOpen}
      setIsOpenModal={setIsOpen}
      modalHeader={collectionName}
      directionToOpen={"right"}
      handleAction={() => setIsOpen(false)}
    >
      {isLoading ? (
        listSkeleton()
      ) : (
        <Box className="collection-detail-modal-wrapper" padding="12px 15px">
          {appList?.app_list?.map((data, idx) => {
            if (!data) return null;

            return (
              <List
                key={data?.id || idx}
                data={data}
                dataLength={appList?.app_list?.length}
                idx={idx}
              />
            );
          })}
        </Box>
      )}
    </Dialog>
  );
}

export default memo(CollectionDetailDialog);
